import { render, staticRenderFns } from "./LoyaltyMember.vue?vue&type=template&id=83aab93c&"
import script from "./LoyaltyMember.vue?vue&type=script&lang=js&"
export * from "./LoyaltyMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports